module.exports = __webpack_public_path__ + "img/brand--dojorsa.edb4a86e.png";